import { Component, Input, OnInit } from '@angular/core';
import { APP_ROUTES } from '../../../contants/APP_ROUTES';
import { PARAMS } from '../../../contants/PARAMS';
import { CLIENT_TRIP_HISTORY } from '../../../contants/columns/columns.client.trip.history';
import { PageOption } from '../../../models/common/pageOption';
import { TableColumn } from '../../../models/tables/TableColumn';
import { ITripSearchResult } from '../../../models/trips/trip';
import { TripFilter } from '../../../models/trips/tripFilter';
import { ParameterService } from '../../../services/parameter.service';
import { TripService } from '../../../services/trip.service';

@Component({
	selector: 'client-trip-history',
	templateUrl: './client-trip-history.component.html',
	styleUrls: ['./client-trip-history.component.css']
})
export class ClientTripHistoryComponent implements OnInit {
	
	@Input() clientId: number = 0;
	columns: TableColumn[] = CLIENT_TRIP_HISTORY;
	data: ITripSearchResult[] = [];
	viewUrl: string = APP_ROUTES.tripForm.replace('/:id', '');
	filter: PageOption<TripFilter>;

	constructor(
		private _tripService: TripService,
		private _parameterService: ParameterService
	) { }

	ngOnInit() {
		this._parameterService.getCachedParameterObject<TableColumn[]>(PARAMS.CLIENT_HISTORY_TABLE_COLUMNS, 3600).subscribe(
			result => {
				if(result.length != 0){
					this.columns = result;
				}
			}
		);

		this.filter = new PageOption<TripFilter>();
		this.filter.searchFilter = new TripFilter();
		this.filter.searchFilter.clientId = this.clientId;
		this.filter.searchFilter.isPaid = false;

		this.fetch();
	}

	fetch() {
		this._tripService.searchV2(this.filter).subscribe(
			result => {
				if(result != undefined){
					this.data = result.data;
				}
			}
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/clients/client-trip-history/client-trip-history.component.ts